import React, { lazy } from 'react';

const DocNumListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/DocNumModule/DocNumListing'
  ).then(module => ({
    default: module.DocNumListing,
  })),
);

const AutoNumberingForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/DocumentNumberingModule/AutoNumberingForm'
  ).then(module => ({
    default: module.AutoNumberingForm,
  })),
);

const DocumentNumberingListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/DocumentNumberingModule/DocumentNumberingListing'
  ).then(module => ({
    default: module.DocumentNumberingListing,
  })),
);

const docNumRoutes = [
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/doc-numbering',
    },
    component: <DocNumListing type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/numbering-structure',
    },
    component: <DocumentNumberingListing type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/numbering-structure/form',
    },
    component: <AutoNumberingForm type="company-setup" />,
  },
];

export default docNumRoutes;
